export default "__VITE_ASSET__Foe3iJI___"